import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "app.scss";
// import { initializeParse } from 'Services/parseConfig';
import Footer from "./components/Footer";
// import Login from "Autho/Login";
import Main from "views/Main";
import Forgotpwd from "./views/Auth/Forgotpwd";
import Assessment from "views/Assessment"
import Landing from "views/Landing"
import "bootstrap/dist/css/bootstrap.min.css";
import PrivacyPolicy from "views/Privacy-policy";

function App() {
  // useEffect(() => {
  //   initializeParse();
  // }
  // , []);


  return (
    <div className="App">
      <Router>
          <Routes>
            {/* <Route path="/login" element={<Login />} /> */}
            <Route path="/domain" element={<Main />} />
            <Route path="/forgotpassword" element={<Forgotpwd />} />
            <Route path="/assessment" element={<Assessment />} />
            <Route path="/" element= {<Landing/>} />
            <Route path="/privacy-policy" element={<PrivacyPolicy/>}/>
          </Routes>
          <Footer />
      </Router>
    </div>
  );
}

export default App;



